export const handleFindOption = (name: string, optionsData: any) => {
  if (optionsData) {
   
    const findItem = optionsData.find((item: any) => {
      return item.optionName === name;
    });
    if (findItem) {
     
      if (findItem.type === 1) {
        return findItem.selectedValue ;
      } else {
        return findItem.optionValueName;
      }
    }
  }
  return "";
};
